import React, { Component } from "react"

export default class Modal extends Component {

    clicked = (e) => {
        console.log("Here")
        window.test = e
        if(e.target.id === "modal-container"){
            this.props.closeModal();
        }
    }

    render(){
        return(
            // <div className="modal show react-modal " tabIndex="-1" role="dialog"
            // onClick={this.clicked} hidden={this.props.hidden}
            // id="modal-container">
            //     <div className="modal-dialog modal-lg" role="document">
            //         <div className="modal-content" onClick={this.contentClicked}>
            //         <div className="modal-header">
            //             <h5 className="modal-title">{this.props.title}</h5>
            //             <button type="button" className="close" data-dismiss="modal" aria-label="Close"
            //              onClick={this.props.closeModal}>
            //             <span aria-hidden="true">&times;</span>
            //             </button>
            //         </div>
            //         <div className="modal-body" style={{'maxHeight': 'calc(100vh - 210px)', 'overflowY': 'auto'}}>
            //             {this.props.body}
            //         </div>
            //         <div className="modal-footer">
            //             <button type="button" className="btn btn-primary">Save changes</button>
            //             <button type="button" className="btn btn-secondary" data-dismiss="modal"
            //              onClick={this.props.closeModal}>Close</button>
            //         </div>
            //         </div>
            //     </div>
            // </div>
            <div id="modal-container" className="modal react-modal fade show lush-modal"
                onClick={this.clicked} hidden={this.props.hidden}  role="dialog">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content" onClick={this.contentClicked}>
                        <div className="modal-header">
                            <h5 className="modal-title">{this.props.title}</h5>
                            <button type="button" onClick={this.props.closeModal} className="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body"  style={{'maxHeight': 'calc(100vh - 210px)', 'overflowY': 'auto'}}>
                            {this.props.body}
                        </div>
                        <div className="modal-footer center">
                            <button type="button" className="btn btn-sm lush-btn" onClick={this.props.closeModal} data-dismiss="modal">Close</button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/Components/Modal.js